import { Tabs, Tab, Box } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { ITabPanelProps } from '../../interface/tab-panel.interface';
import Participants from './Participants';
import Analytics from './Analytics';
import { ILearningGamePlayerRank } from '../../interface/learning-game-player-rank.interface';
import { Column, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import {
  fetchJourney,
  getAnalytics,
  getGenieLearningGamePlayerLeaderboard,
} from '../../common/api/apicall';
import { months } from '../../common/constants';
import { useParams } from 'react-router-dom';
import { IDatableColumn } from '../../common/leaderboard/column.interface';


function isBeforeDate(isoDate:string) {
  const userDate = new Date(isoDate);
  // 20:00 IST = 14:30 UTC
  const targetDate = new Date(Date.UTC(2025, 10, 20, 14, 30, 0));

  // console.log({targetDate , userDate})
  return userDate < targetDate;
}

const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60)
    .toString()
    .padStart(2, '0');
  const secs = (seconds % 60).toString().padStart(2, '0');
  return `${mins}:${secs}`;
};

function TabPanel(props: ITabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

const SBM_COMPANY_ID = '68c00e4b07fb52df2f1d42dc';
const ABB_COMPANY_ID = '68ee0b8c811929aacddc3d8d';
export default function GenieStaging(props: { env: 'prod' | 'staging' }) {
  const [value, setValue] = useState(0);
  const [data, setData] = useState<ILearningGamePlayerRank[]>([]);
  const [analyticsData, setAnalyticsData] = useState<ILearningGamePlayerRank[]>(
    [],
  );
  const { id: journeyId } = useParams();
  const [journeyDetails, setJourneyDetails] = useState<{
    name: string;
    divisionId: string;
    gameFormat: string;
    createdAt: string;
    companyId: string;
  }>();

  const newColumns =
    ((journeyDetails as any)?.gameFormat === 'JumblesGame'
      ? (journeyDetails as any)?.jumbles
      : (journeyDetails as any)?.questions
    )?.map((item: any, index: any) => {
      return {
        header: item.text, //`Q${index + 1}`,
        key: `q-${item._id}`,
        width: 50,
        style: { alignment: { wrapText: true } },
      };
    }) || [];

  const worksheetColumns = [
    { header: 'Learner Id', key: 'learnerId', width: 40 } as Column,
    { header: 'Name', key: 'name', width: 40 } as Column,
    { header: 'Email', key: 'email', width: 40 } as Column,
    ...(journeyDetails?.companyId === '684a3ce1db4f66991573f720'
      ? [
          { header: 'Designation', key: 'designation', width: 30 } as Column,
          { header: 'Mobile Number', key: 'mobileNo', width: 30 } as Column,
          { header: 'CU/Zone', key: 'zone', width: 30 } as Column,
          { header: 'State', key: 'state', width: 30 } as Column,
          { header: 'Territory', key: 'territory', width: 30 } as Column,
          { header: 'Reporting Manager Name', key: 'manager', width: 40 } as Column,
        ]
      : []),
    {
      header: 'Highest Score',
      key: 'highestScore',
      width: 30,
      alignment: { horizontal: 'center' },
    } as Column,
    {
      header: 'Accuracy (Percentage)',
      key: 'accuracy',
      width: 30,
    } as Column,
    {
      header: 'Overall Time',
      key: 'elapsedTime',
      width: 30,
    } as Column,
    { header: 'Last Completed Date', key: 'completedAt', width: 30 } as Column,
    ...newColumns,
  ];

  useEffect(() => {
    async function getGenieJourney() {
      try {
        const journey = await fetchJourney(
          journeyId as string,
          props.env === 'prod',
        );
        let isJumbles = journey.gameFormat === 'JumblesGame';
        setJourneyDetails(journey);

        getAnalytics(journey.divisionId, props.env === 'prod', isJumbles).then(
          (analytics) => {
            console.log({ analytics });
            // Process the analytics data
            const processedData = analytics.map(
              (
                question: {
                  correctOnFirstAttempt: number;
                  totalPlayers: number;
                  questionText: any;
                  jumbleHint: any;
                },
                index: number,
              ) => {
                const accuracy = (
                  (question.correctOnFirstAttempt / question.totalPlayers) *
                  100
                ).toFixed(2);

                return {
                  number: index + 1,
                  question: isJumbles
                    ? question.jumbleHint
                    : question.questionText,
                  accuracy: question.totalPlayers ? `${accuracy}%` : '',
                };
              },
            );

            setAnalyticsData(processedData);
          },
        );

        getGenieLearningGamePlayerLeaderboard(
          journey.divisionId,
          props.env === 'prod',
          {
            includeNonPostive: true,
            scorePosition:
              journey.companyId === SBM_COMPANY_ID ? 'first' : undefined,
          },
        )
          .then((res: any[]) => {
            const filteredPlayers: any[] = [];
            res.forEach((player, index) => {
              player['name'] =
                (player['firstName'] || '') +
                ' ' +
                (player['lastName'] || '') +
                (player['lastname'] || '');
              player['highestScore'] =
                journey.companyId === SBM_COMPANY_ID
                  ? player['highestScoreHistory']
                  : journey.companyId === ABB_COMPANY_ID &&
                    journey.gameFormat === 'SwipeGame2'
                  ? !player['gameOver'] && isBeforeDate(player['completedAt'])
                    ? Math.round((player['lastHighestScoreHistory'] / 300) * 100)
                    : player['lastHighestScoreHistory']
                  : player['lastHighestScoreHistory'];
                console.log({isJumbles} , player.analytics['questions'])
              player.analytics[isJumbles ? 'jumbles' : 'questions']?.map(
                (item: any) => {
                  // 1s *100/ (0s +1s)
                  player[`q-${isJumbles ? item.jumbleId : item.questionId}`] =
                    item.attempt === 0 ? 1 : 0;
                },
              );

              const numberOfOnes = player.analytics[
                isJumbles ? 'jumbles' : 'questions'
              ]?.filter((item: any) => item.attempt === 0)?.length;
              const numberOfOnesOrZeros =
                player.analytics[isJumbles ? 'jumbles' : 'questions']?.length;
              // console.log({numberOfOnes , numberOfOnesOrZeros} , player.analytics.questions)

              const calculatedAccuracy =
                (numberOfOnes * 100) / numberOfOnesOrZeros;
              player['accuracy'] = isNaN(calculatedAccuracy)
                ? ''
                : calculatedAccuracy.toFixed(2);

              // console.log({numberOfOnesOrZeros , player})
              if (player.extraDetail) {
                player['employeeid'] = player.extraDetail['employeeid'];
                if (journey.companyId === ABB_COMPANY_ID) {
                  player['elapsedTime'] =
                    !isNaN(player.extraDetail['fullGameTimeRemaining']) &&
                    player.extraDetail['fullGameTimeRemaining'] < 720
                      ? formatTime(
                          720 - player.extraDetail['fullGameTimeRemaining'],
                        )
                      : '';
                } else {
                  player['elapsedTime'] = player.extraDetail['elapsedTime']
                    ? formatTime(player.extraDetail['elapsedTime'])
                    : '';
                }
              }

              if (player['email']?.trim()?.toLowerCase() === 'test@test.com') {
                player['email'] = '';
              }

              if (player['completedAt']) {
                const date = new Date(player['completedAt']);
                player['completedAt'] = !player['gameOver']
                  ? ``
                  : date.toLocaleDateString('en-US', {
                      day: 'numeric',
                      // weekday: 'short',
                      year: 'numeric',
                      month: 'long',
                      hour: 'numeric',
                      minute: 'numeric',
                      second: 'numeric',
                    });
                // player['completedAt'] = !player['gameOver']
                //   ? ``
                //   : `${date.getDate()} ${
                //       months[date.getMonth()]
                //     }, ${date.getFullYear()}`;
              }
              //     if (player.extraDetail) {
              filteredPlayers.push(player);
              //  }
            });
            setData(filteredPlayers);
          })
          .catch((error) => console.log('error: ', error));
      } catch (error) {}
    }
    getGenieJourney();
  }, []);

  function download() {
    const workbook = new Workbook();
    const participantSheet = workbook.addWorksheet('Participant data');
    participantSheet.columns = worksheetColumns;
    // worksheet.columns = worksheetColumns;
    participantSheet.addRows(data);

    const analyticsSheet = workbook.addWorksheet('Question level analytics');
    analyticsSheet.columns = [
      { header: 'Question no', key: 'number', width: 50 } as Column,
      { header: 'Question text', key: 'question', width: 50 } as Column,
      { header: 'Accuracy', key: 'accuracy', width: 50 } as Column,
    ];
    analyticsSheet.addRows(analyticsData);

    const legendSheet = workbook.addWorksheet('Legend');
    legendSheet.columns = [
      { header: 'Journey Name', key: 'name', width: 50 } as Column,
      { header: 'Creation Date', key: 'date', width: 50 } as Column,
      { header: 'Game Format', key: 'format', width: 50 } as Column,
    ];
    let date = new Date(journeyDetails?.createdAt as string);
    legendSheet.addRows([
      {
        name: journeyDetails?.name,
        format: journeyDetails?.gameFormat,
        date: `${date.getDate()} ${
          months[date.getMonth()]
        }, ${date.getFullYear()}`,
      },
    ]);

    workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      fs.saveAs(
        blob,
        `${journeyDetails?.name}  (Participants data) ` + '.xlsx',
      );
    });
  }

  const handleChange = (event: any, newValue: number) => {
    console.log('event: ', event, 'newValue: ', newValue);

    setValue(newValue);
  };

  // const classes = useStyles();

  return (
    <>
      <Tabs
        value={value}
        variant="scrollable"
        scrollButtons="auto"
        onChange={(event, i) => handleChange(event, i)}
        aria-label="scrollable auto tabs example"
      >
        <Tab label="Participants" style={{ fontSize: 13 }} {...a11yProps(0)} />
        <Tab label="Analytics" style={{ fontSize: 13 }} {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Participants
          participantsData={data}
          analyticsData={analyticsData}
          download={download}
          journeyDetails={journeyDetails!}
        />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Analytics
          participantsData={data}
          analyticsData={analyticsData}
          download={download}
          journeyDetails={journeyDetails!}
        />
      </TabPanel>
    </>
  );
}
